export const CONTACTS = { email: "questanizer@gmail.com" };
